export const noticeKeys = {
  noticeList: ['noticeList'] as const,
};
